/* eslint-disable no-unsafe-optional-chaining */
import React from "react";

import { Grid } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import {
  Timeline,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
  TimelineItem,
  TimelineOppositeContent,
} from "@mui/lab";

import useStyles from "./styles";

// interface ItemBase {
//   icon?: React.ReactNode;
//   title?: React.ReactNode;
//   content?: React.ReactNode;
// }

interface Props<T> {
  items?: T[];
  renderIcon?: (item: T) => React.ReactNode;
  icon?: React.ReactNode;
  renderTitle?: (item: T) => React.ReactNode;
  renderSubtitle?: (item: T) => React.ReactNode;
  iconDotVariant?: "outlined";
  useBrandColor?: boolean;
}

const TimeLine = <T,>({
  items,
  icon,
  renderIcon,
  renderTitle,
  renderSubtitle,
  iconDotVariant,
  useBrandColor,
}: Props<T>) => {
  const classes = useStyles({ useBrandColor });

  const TimeLineItemStyle = withStyles({
    missingOppositeContent: {
      "&:before": {
        display: "none",
      },
    },
  })(TimelineItem);

  if (!items?.length) return null;

  return (
    <Timeline data-cy="timeline" className="pl-0">
      {items.map((item, index: number) => (
        <TimeLineItemStyle key={index} className={classes.item}>
          <TimelineOppositeContent className={classes.opposite} />

          <TimelineSeparator>
            <TimelineDot className={classes.customTimelineDot} variant={iconDotVariant}>
              {renderIcon?.(item) ?? icon}
            </TimelineDot>
            {items?.length - 1 !== index && <TimelineConnector className={classes.connector} />}
          </TimelineSeparator>

          <TimelineContent className={classes.content}>
            <Grid container direction="column" alignItems="flex-start" className={classes.grid}>
              {renderTitle?.(item)}
              {renderSubtitle?.(item)}
            </Grid>
          </TimelineContent>
        </TimeLineItemStyle>
      ))}
    </Timeline>
  );
};

export default TimeLine;
